import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import { DS_ALERT_VARIANT, DSAlertVariant } from "@/src/design_system/feedback/alert/types/variant";

export const DS_ALERT_VARIANT_TO_ICON_MAP: Record<DSAlertVariant, DSIconName> = {
  [DS_ALERT_VARIANT.Info]: "info",
  [DS_ALERT_VARIANT.Success]: "success",
  [DS_ALERT_VARIANT.Warning]: "warning",
  [DS_ALERT_VARIANT.Error]: "error",
} as const;
